import type { Cycle } from "@src/packages/care/components/frozen-storage-data";

/**
 * A specimen intake needs enough biology to create a record. Source,
 * storage state, facility, and cycle linkage are additional details that can
 * be added later when the patient has them; none of those details decide
 * whether the biology itself is complete.
 */
export function isValidSpecimenCycle(cycle: Cycle): boolean {
  const isEmbryo = cycle.type === "embryos";
  const hasDate =
    cycle.type === "eggs"
      ? cycle.oocyte.freezeDate || cycle.oocyte.retrievalDate
      : cycle.type === "sperm"
        ? cycle.sperm.freezeDate || cycle.sperm.collectedAt
        : cycle.embryo.freezeDate || cycle.embryo.fertilisationDate;
  const hasFrozenCount =
    cycle.type === "eggs"
      ? cycle.oocyte.numberFrozen > 0
      : cycle.type === "sperm"
        ? cycle.sperm.numberFrozen > 0
        : cycle.embryo.numberFrozen > 0;
  const hasEmbryoDevelopment =
    !isEmbryo ||
    (cycle.embryoEntryMode === "group"
      ? Boolean(
          cycle.embryo.dayOfDevelopment &&
          cycle.embryo.fertilisationMethod &&
          cycle.embryo.pgtPerformed,
        )
      : cycle.embryo.individualEntries.every((entry) =>
          Boolean(entry.dayOfDevelopment && entry.status),
        ));

  return Boolean(hasDate) && hasFrozenCount && hasEmbryoDevelopment;
}
